import React from "react";
import * as Icon from "react-feather";

const navigationConfig = [
  // ================================
  // DASHBOARD
  // ================================
  {
    type: "groupHeader",
    groupTitle: "DASHBOARD",
  },
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: [
      "TI",
      // "SEKRETARIS",
      // "SESDIR",
      // "DIRUT",
      // "DIRKEU",
      // "DIROPS",
      // "DIVISI",
    ],
    navLink: "/dashboard",
  },

  // ================================
  // ACCOUNT MANAGEMENT
  // ================================
  {
    type: "groupHeader",
    groupTitle: "ACCOUNT",
    permissions: ["TI", "SEKRETARIS","SESDIR"]
  },
  {
    id: "create_account",
    title: "Buat User",
    type: "item",
    icon: <Icon.Users size={20} />,
    permissions: ["TI"],
    navLink: "/account/create_account",
  },

  {
    id: "ubah_password",
    title: "Ubah Password",
    type: "item",
    icon: <Icon.Lock size={20} />,
    permissions: [
      "TI",
      "SEKRETARIS",
      "SESDIR",
      "DIRUT",
      "DIRKEU",
      "DIROPS",    
      "KEPALA",
      "MANAJER",

    ],
    navLink: "/account/ubah_password",
  },

  // ================================
  // SURAT / DISPOSISI
  // ================================
  {
    type: "groupHeader",
    groupTitle: "E-DISPOSISI",
  },

  // INPUT SURAT
  {
    id: "buat_surat",
    title: "Buat Surat",
    type: "item",
    icon: <Icon.Edit size={20} />,
    permissions: ["KEPALA", "SEKRETARIS", "TI","SESDIR", "MANAJER"],
    navLink: "/surat/buat",
  },

  // VERIFIKASI SEKRETARIS
  // {
  //   id: "verifikasi_surat",
  //   title: "Verifikasi Surat",
  //   type: "item",
  //   icon: <Icon.CheckCircle size={20} />,
  //   permissions: ["SEKRETARIS", "TI"],
  //   navLink: "/surat/verifikasi",
  // },

  // DISPOSISI DIREKTUR
  {
    id: "disposisi_direktur",
    title: "Direksi",
    type: "item",
    icon: <Icon.CornerDownRight size={20} />,
    permissions: ["DIRUT", "DIRKEU", "DIROPS", "TI","SESDIR"],
    navLink: "/surat/disposisiBOD",
  },
  // SURAT MASUK DEPARTEMEN / SBU
  {
    id: "disposisi_departemen",
    title: "Dept. / SBU",
    type: "item",
    icon: <Icon.Briefcase size={20} />,
    permissions: ["MANAJER", "TI", "KEPALA", "SEKRETARIS"],
    navLink: "/surat/disposisiDepartemen",
  },

  // SURAT MASUK  
  {
    id: "surat_masuk",
    title: "Surat Masuk",
    type: "item",
    icon: <Icon.Inbox size={20} />,
    permissions: [
      "SESDIR",
      "TI",
    ],
    navLink: "/surat/masuk",
  },

  // SURAT KELUAR
  {
    id: "surat_keluar",
    title: "Surat Keluar",
    type: "item",
    icon: <Icon.Send size={20} />,
    permissions: [
   
      "TI",
    ],
    navLink: "/surat/keluar",
  },

  // TRACKING
  {
    id: "tracking_surat",
    title: "Tracking Surat",
    type: "item",
    icon: <Icon.Activity size={20} />,
    permissions: [
      "IT",
      "SEKRETARIS",
      "SESDIR",
      "DIRUT",
      "DIRKEU",
      "DIROPS",
      "MANAJER",
      "TI",
      "KEPALA",
    ],
    navLink: "/surat/tracking",
  },

  // ARSIP
  {
    id: "arsip_surat",
    title: "Arsip Surat",
    type: "item",
    icon: <Icon.Trash size={20} />,
    permissions: [
      "TI",
      "SEKRETARIS",
      "SESDIR",
      "DIRUT",
      "DIRKEU",
      "DIROPS",
      "MANAJER",
      "KEPALA",
    ],
    navLink: "/surat/arsip",
  },

  // ARSIP
  {
    id: "riwayat_surat",
    title: "Riwayat Surat",
    type: "item",
    icon: <Icon.Archive size={20} />,
    permissions: [
      "TI",
      "SEKRETARIS",
      "SESDIR",
      "DIRUT",
      "DIRKEU",
      "DIROPS",
      "MANAJER",
      "KEPALA",
    ],
    navLink: "/surat/riwayat",
  },

  // ================================
  // LAPORAN
  // ================================
  // {
  //   type: "groupHeader",
  //   groupTitle: "LAPORAN",
  // },
  // {
  //   id: "laporan_surat",
  //   title: "Laporan Surat",
  //   type: "item",
  //   icon: <Icon.FileText size={20} />,
  //   permissions: ["TI", "SEKRETARIS"],
  //   navLink: "/laporan/surat",
  // },

  // ================================
  // SYSTEM
  // ================================
  // {
  //   type: "groupHeader",
  //   groupTitle: "SYSTEM",
  // },
  // {
  //   id: "log_activity",
  //   title: "Log Activity",
  //   type: "item",
  //   icon: <Icon.Database size={20} />,
  //   permissions: ["TI"],
  //   navLink: "/system/log",
  // },
];

export default navigationConfig;